import React, { FC, ReactElement } from 'react'
import {
  MenuButton as ChakraMenuButton,
  MenuButtonProps as ChakraMenuButtonProps,
  Menu as ChakraMenu,
  MenuProps as ChakraMenuProps,
  MenuItem as ChakraMenuItem,
  MenuItemProps
} from '@chakra-ui/react'
import { buttonEffects } from '../form/button/ButtonChakra'
import { brandColors } from 'front-end/../shared/basicPalette'

type MenuButtonProps = ChakraMenuButtonProps & {
  circular?: boolean
  variant?: 'filled' | 'outline'
  dataTest?: string
  rightIcon?: ReactElement
}

const MenuButton: FC<MenuButtonProps> = (props) => {
  const {
    circular,
    dataTest = 'MenuButton',
    variant = 'filled', // Menu in Chakra doesn't have ability to configure variant
    ...rest
  } = props
  const outlineStyle =
    variant === 'outline'
      ? {
          color: brandColors.grey[500],
          bg: 'transparent',
          borderColor: brandColors.grey[300]
        }
      : {}

  return (
    <ChakraMenuButton
      borderRadius={circular ? '50%' : undefined}
      tabIndex={0}
      data-test={dataTest}
      {...outlineStyle}
      {...buttonEffects(15)}
      {...rest}
    />
  )
}

export type MenuProps = ChakraMenuProps & {
  dataTest?: string
}

const Menu: FC<MenuProps> = (props) => {
  const { autoSelect, dataTest = 'Menu', ...rest } = props

  return (
    <ChakraMenu
      data-test={dataTest}
      autoSelect={autoSelect ?? false}
      {...rest}
    />
  )
}

const MenuItem: FC<MenuItemProps> = (props) => {
  return <ChakraMenuItem bgColor="white" {...props} />
}

export { MenuButton, Menu, MenuItem }
